
  import {Vue} from "vue-property-decorator";
  import Component from "vue-class-component";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import router from "../../router";
  import FormCotizacion from "./FormCotizacion.vue"
  
  @Component({
    name: "CotizacionesIndex",
    components: {FormCotizacion}
  })
  export default class CotizacionesIndex extends Vue {
    
    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    public swEditar = false;
    public cotizacion_selected = null;
    public swForm = false;
    public swVer = false;
    public fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
    public fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
    $refs!: {
      form: HTMLFormElement,
    };
    public txtSearch = "";
    mounted(){
      this.getCotizaciones();
    }
    getCotizaciones(){
      this.loading
      let data = {
        page: this.pagination.current_page,
        txtSearch: this.txtSearch,
				fecha_inicial: this.fechaInicial,
				fecha_final: this.fechaFinal
      }
      this.consultorioService.getCotizaciones(data)
    }
    nuevo(){
      this.swEditar = false;
      this.swForm = true;
    }
    editar(cotizacion:any){
      this.swForm = true;
      this.swEditar = true;
      this.cotizacion_selected = cotizacion;
      this.swVer = false;

    }
    abrirDetalle(cotizacion:any){
      this.swForm = true;
      this.swEditar = true;
      this.cotizacion_selected = cotizacion;
      this.swVer = true;
    }
        
    get datos(): any {
      return this.consultorioStore.cotizaciones;
    }
    get pagination(): any {
      return this.consultorioStore.pagination;
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  